import useAxiosPrivate from "../hooks/useAxiosPrivate.js";
import React, { useState, useEffect, useCallback } from "react";
import { Button, Form, Input } from "antd";
import '../Global.css';
import SharedSettings from "../SharedSettings.js";

const PortfolioSettings = (props) => {

    const axiosPrivate = useAxiosPrivate();

    const [isLoading, setIsLoading] = useState(false);
    const [portName,setPortName] = useState("");

    //const [leagueTimeframe, setLeagueTimeframe] = useState("2025");


    const [portViewable,setPortViewable] = useState("Yes");

    const [settingsData,setSettingsData] = useState({});


    const [changeName,setChangeName] = useState(false);
    const [changeNameSuccess,setChangeNameSuccess] = useState(false);
    const [nameErrMsg,setNameErrMsg] = useState("");
    const [nameErr,setNameErr] = useState(false);
    const [changeViewable,setChangeViewable] = useState(false);
;
    const fetchData = useCallback( async() => {
        setIsLoading(true);
        const dataSend = {port_id:props.port_id};
        console.log(dataSend);
        try {
            const response = await axiosPrivate.post('/portfolio/getSettings',dataSend)

            const settings = response.data[0];

            console.log("get port settings data response");
            console.log(response.data); //debugger

            let maxSharesPerTeam = "No";
            let playoffMultipliers = "No";
            let leagueShorting = "Blocked";
 
            //setIsLoading(false);
            setPortName(settings.port_name);
            const leagueSportId = (settings.sport_league_id);
            const timeframe = ((settings.timeframe<0) ? String(settings.timeframe*-1) : (settings.timeframe_name));
            const leagueInseason = (settings.inseason ? "Yes" :"No");

            const lg_format = settings.lg_format;

            const roster_data = new Map();
            let transCostString = '';
            let budget = 0;

            if (lg_format===0){
                budget = (settings.budget)
                //setLeagueTransType(settings.trans_cost_type);

                //setLeagueTransType(settings.trans_cost_type);
                //setLeagueTransAmnt(settings.transaction_cost);
                //setLeagueTransPercent(settings.transaction_cost_percent);
                //setLeagueTransPershare(settings.transaction_cost_pershare);

                let first = false;
                if (settings.trans_cost_type===1){
                    transCostString += "Global: "
                }
                if (Number(settings.transaction_cost)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += ("$" + Number(settings.transaction_cost).toFixed(2))
                }
                if (Number(settings.transaction_cost_percent)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += (Number(settings.transaction_cost_percent).toFixed(2) + "%")
                }
                if (Number(settings.transaction_cost_pershare)>0.0){
                    if (first){
                        transCostString += " + "
                    }
                    else {
                        first = true;
                    }
                    transCostString += (Number(settings.transaction_cost_pershare).toFixed(2) + " per Share.")
                }
                if (!first){
                    transCostString = "Free";
                }

                leagueShorting = (settings.shorting ? "Allowed" : "Blocked")

                if (settings.viewable){
                    setPortViewable("Yes");
                }
                else {
                    setPortViewable("No");
                }

            }
            else if (lg_format===1){

                if (settings.maxsharesperteam){
                    const maxteamshares = settings.maxsharesperteam;
                    if (maxteamshares===1){
                        maxSharesPerTeam = "Yes"
                    }
                    else if (maxteamshares>1){
                        maxSharesPerTeam = (String(maxteamshares))
                    }
                }

                playoffMultipliers = (settings.playoff_multipliers ?  "Yes" : "No");

                const response2 = await axiosPrivate.post('/portfolio/getRosterSettings',dataSend);

                console.log(response2.data)

                for (const pos of response2.data){
                    roster_data.set(pos.position_id,pos.quantity);
                }

                console.log(roster_data)
                //setRosterData(roster_data);

            }

            const sData = {
                sportId: leagueSportId,
                timeframe: timeframe,
                format: lg_format,
                budget: budget,
                transactionType: transCostString ,
                shorting: leagueShorting,
                inseason: leagueInseason,
                multiplers: playoffMultipliers,
                maxSharesPerTeam: maxSharesPerTeam,
                rosterData: roster_data


            }
            setSettingsData(sData);
            setIsLoading(false);
        }
        catch (err){

        }
      }, [axiosPrivate,props.port_id])
    
      useEffect( () => {
        fetchData();
      }, [fetchData]);

      const changeNameOn = () => {
        setChangeName(true);
        setChangeNameSuccess(false);
      }

      const updatePortName = async(e) => {
        console.log(e);
        const data = {
            new_portname: e.newname,
            port_id: props.port_id
        }

        console.log(data);

        try {
            await axiosPrivate.post('/portfolio/updateName',data);
            setChangeNameSuccess(true);
            await fetchData();
        }
        catch (err) {
            if (err.response?.data?.message){
                console.log(err.response?.data?.message);
                setNameErrMsg("Portfolio Name Update Failed: " + err.response?.data?.message);
              }
              else {
                setNameErrMsg("Portfolio Name Update Failed: " + err.message);
              }
              setNameErr(true);
        }
      }

      const changePrivacy = () => {
        setChangeViewable(true);
      }

      const updatePortViewable = async(e) => {
        console.log(e);
        var currViewable;
        if (portViewable==='Yes'){
            currViewable = true;
        }
        else {
            currViewable = false;
        }
        const data = {
            viewable: !currViewable,
            port_id: props.port_id
        }

        console.log(data);

        try {
            await axiosPrivate.put('/portfolio/updatePrivacy',data);
            setChangeViewable(false);
            await fetchData();
        }
        catch (err) {
            if (err.response?.data?.message){
                console.log(err.response?.data?.message);
              }
              else {
                console.log(err.message);
              }
              setChangeViewable(false);
              await fetchData();
        }
      }


      return (
        <span>
        {!isLoading &&
        <div>
            <br></br>Portfolio Name: {portName}
            <div class='divider'/> <Button size="small" onClick={changeNameOn}>Change Name</Button>
            <br></br>Portfolio Viewable: {portViewable} <div class='divider'/> <Button size="small" onClick={changePrivacy}>Change</Button>
            <SharedSettings settingsData={settingsData} />

            {changeName &&
            <span>
                {!changeNameSuccess && <span>
                    {nameErr && <div>{nameErrMsg}</div>}
                    {!nameErr && <span>
                        <div></div>
                        <div>
                            <Form onFinish={updatePortName}>
                                <Form.Item name="newname" label="Enter New Portfolio Name">
                                    <Input />
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" >Update Name</Button>
                                </Form.Item> 
                            </Form>
                        </div>
                    </span>}
                </span>}
                {changeNameSuccess && <div> Name Successfully Updated!</div>}
            </span>}

            {changeViewable && <span>
                <Button onClick={updatePortViewable}>Confirm Change to Viewable</Button>
                    </span> }


        </div>}
        {isLoading && <div> Retrieving Portfolio Settings</div>}
        </span>

      )

}


export default PortfolioSettings;